<template>
  <!-- MBR093 language picker: opened by the Home top-bar language button (#mbr-language-sheet) -->
  <div
    class="modal modal-bottom fade"
    id="mbr-language-sheet"
    tabindex="-1"
    role="dialog"
    aria-labelledby="mbr-language-sheet-title"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content mbr-lang">
        <div class="mbr-lang__top">
          <span class="mbr-lang__handle" aria-hidden="true"></span>
          <!-- keep .btn-close: views close every open sheet with $(".btn-close").click() -->
          <button type="button" class="btn-close mbr-lang__close" data-bs-dismiss="modal" :aria-label="$t('common.close')">
            <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        <h2 id="mbr-language-sheet-title" class="mbr-lang__title">{{ $t('language.title') }}</h2>
        <ul class="mbr-lang__list" role="listbox" :aria-label="$t('language.title')">
          <li v-for="lang in languages" :key="lang.code">
            <button
              type="button"
              class="mbr-lang__option"
              :class="{ 'mbr-lang__option--active': lang.code === $i18n.locale }"
              role="option"
              :aria-selected="lang.code === $i18n.locale ? 'true' : 'false'"
              :lang="lang.code"
              data-bs-dismiss="modal"
              @click="choose(lang.code)"
            >
              <span class="mbr-lang__text">
                <span class="mbr-lang__label">{{ lang.label }}</span>
                <span v-if="lang.name !== lang.label" class="mbr-lang__name" lang="en">{{ lang.name }}</span>
              </span>
              <svg v-if="lang.code === $i18n.locale" class="mbr-lang__check" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { LANGUAGES, setLocale } from "@/i18n";

export default {
  name: "MbrLanguageSheet",
  data() {
    return {
      languages: LANGUAGES,
    };
  },
  methods: {
    choose(code) {
      setLocale(code);
    },
  },
};
</script>

<style scoped>
/* same white MBR bottom sheet as QrcodeMember */
.modal.modal-bottom .modal-content.mbr-lang {
  padding: 12px 24px 32px;
  background: var(--mbr-color-surface);
  border: 0;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
  max-height: 92vh;
}

.mbr-lang__top {
  position: relative;
  display: flex;
  justify-content: flex-end;
  min-height: 36px;
}

.mbr-lang__handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 4px;
  background: var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  transform: translateX(-50%);
}

/* reset Bootstrap's .btn-close (svg background, 1em box, 50% opacity) */
.mbr-lang__close.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint) none;
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
  opacity: 1;
}

.mbr-lang__close.btn-close:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
  box-shadow: none;
}

.mbr-lang__close svg {
  width: 16px;
  height: 16px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-lang__title {
  margin: 4px 0 16px;
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-headline-sm-size);
  font-weight: var(--mbr-headline-sm-weight);
  line-height: var(--mbr-headline-sm-line);
  letter-spacing: var(--mbr-headline-sm-tracking);
  color: var(--mbr-color-ink-headline);
}

.mbr-lang__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.mbr-lang__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 56px;
  padding: 10px 16px;
  background: var(--mbr-color-tint);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-lg);
  color: var(--mbr-color-ink-headline);
  text-align: left;
  transition: transform 0.12s ease;
}

.mbr-lang__option:active {
  transform: scale(0.98);
}

.mbr-lang__option:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}

.mbr-lang__option--active {
  background: var(--mbr-color-surface);
  border-color: var(--mbr-color-primary);
}

.mbr-lang__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.mbr-lang__label {
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
}

.mbr-lang__name {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--mbr-color-ink-muted);
}

.mbr-lang__check {
  flex: none;
  width: 20px;
  height: 20px;
  color: var(--mbr-color-primary);
}
</style>
